import { HTCMDService, htcmdService } from 'js/services/htcmd.service';

HTCMDService.prototype.goToExternalPage = function(url) {
    this.sendMessage('goToExternalPage', { pageUrl: url });
};

HTCMDService.prototype.openLogin = function() {
    this.sendMessage('openLogin');
};

export { htcmdService };
